import {api_smart} from '@/utils/request'
import axios from '@/utils/request'

//扫码活动概况
export const showSurvey = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/info',
     method: 'get',
     params
   })
};
//扫码活动 线 
export const scan_statistical = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/scan_statistical',
     method: 'get',
     params
   })
};


//扫码活动管理 --活动列表
export const activitys = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/list',
     method: 'get',
     params
   })
};

// 活动列表范围   ---出货单
export const get_chd_range_list = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/chd_range_list/'+activity_id,
     method: 'get',
     params
   })
};

// 活动列表范围   ---批次号
export const get_batch_range_list = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/batch_range_list/'+activity_id,
     method: 'get',
     params
   })
};

//扫码活动管理 --活动活动禁用及修改优先
export const activitysSwitch= (id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/switch_options/'+id,
     method: 'PATCH',
     data
   })
};
//扫码活动管理 --活动活动删除
export const activitysDel= (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/'+id,
     method: 'DELETE'
   })
};
//扫码活动管理 --活动活动数据
export const activitysStatics= (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/show_statistics/'+activity_id,
     method: 'get'
   })
};
//扫码活动管理 --活动活动资料收集列表
export const getCollectionList= (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activity/show_collection/'+activity_id,
     method: 'get',
     params
   })
};


//扫码活动管理 --活动活动资料收集详情
export const showCollectionInfo= (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activity/show_collection_info/'+activity_id,
     method: 'get',
     params
   })
};



//统计 门店统计
export const activity_store_count= (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/activity_store_count',
     method: 'get',
     params
   })
};
//统计 门店统计
export const activity_store_statisticals= (params)=>{
  return api_smart.request({
     url: '/admin/guide/activity_situation/activity_store_statisticals',
     method: 'get',
     params
   })
};
//统计 扫码统计
export const activity_store_code= (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/store_clerk/scan',
     method: 'get',
     params
   })
};









// 创建活动第一步
// 添加
export const activitysOneCreate = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/create',
     method: 'post',
     data
   })
};
// 详情
export const activitysOneDetail = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/detail/'+activity_id,
     method: 'get',
     params
   })
};
// 更新
export const activitysOneUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/update/'+activity_id,
     method: 'PUT',
     data
   })
};
// 第一步结束


// 创建活动第二步
// 详情
export const activitysTwoDetail = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/list/'+activity_id,
     method: 'get',
     params:{activity_id}
   })
};



// 活动范围-添加
export const activitysTwoUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/batch_small_code/'+activity_id,
     method: 'PUT',
     data
   })
};
// 活动范围-删除
export const activitysTwoDel = (id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/'+id,
     method: 'DELETE',
     data
   })
};
// 出库单模式 ---活动范围
export const activitysRangeList = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/range_list/'+activity_id,
     method: 'get',
     params:{activity_id}
   })
};

// 出库单模式 ---已选出库单列表
export const activitysRangeOutList = (range_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/show_range_out_warehousing_sn_list/'+range_id,
     method: 'get',
     params
   })
};

// 获取批次号
export const activitysSnRangeList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/batch_sn_list',
     method: 'get',
     params
   })
};

// 获取批次号详情
export const activitysSnRangeDetail = (batch_sn)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/batch_sn_info/'+batch_sn,
     method: 'get'
   })
};
// 数据更新
export const activitysSnRangeUpdateData = (activity_id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/refresh/'+activity_id,
     method: 'get'
   })
};
// 数据更新记录
export const activitysSnRangeUpdateDataLogs = (range_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/get_refresh_log/'+range_id,
     method: 'get',
     params
   })
};
// 获取入库单号
export const get_out_warehousing_list = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/get_out_warehousing_list',
     method: 'get',
     params
   })
};
//增加入库单 条件
export const set_out_warehousing_list = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/store_out_warehousing_sn_to_range',
     method: 'post',
     data
   })
};
//修改入库单 条件
export const update_out_warehousing_list = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/update_out_warehousing_sn_to_range',
     method: 'PUT',
     data
   })
};
//自动条件 -详情
export const show_range_info = (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/show_range_info/'+id,
     method: 'get'
   })
};
//自动条件 -修改
export const update_matching_condition_to_range = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/update_matching_condition_to_range',
     method: 'PUT',
     data
   })
};

//入库单 条件  --详情
export const detail_out_warehousing_list = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/update_out_warehousing_sn_to_range',
     method: 'PUT',
     data
   })
};


//添加范围->指定匹配条件
export const store_matching_condition_to_range = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/store_matching_condition_to_range',
     method: 'post',
     data
   })
};
// 删除
export const delRanges = (range_id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/chd_mode/'+range_id,
     method: 'DELETE',
     
   })
};


// 第二步结束

// 
// tab-获取批次号
export const batch_sn_list = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/ranges/batch_mode/batch_sn_list',
     method: 'get',
     params
   })
};

// 导购扫码设置获取
export const get_guide_scan_config = ()=>{
  return api_smart.request({
     url: 'admin/guide/scan_config',
     method: 'get'
   })
};
// 导购扫码设置获取
export const update_guide_scan_config = (data)=>{
  return api_smart.request({
     url: 'admin/guide/scan_config',
     method: 'PUT',
     data
   })
};

// 导购验证页设置获取
export const get_verification_page_config = ()=>{
  return api_smart.request({
     url: 'admin/guide/verification_page_config',
     method: 'get'
   })
};
// 更新导购验证页设置
export const  update_verification_page_config = (data)=>{
  return api_smart.request({
     url: 'admin/guide/verification_page_config',
     method: 'PUT',
     data
   })
};


// 导购统计
export const guide_activity_statistical = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/activity_statistical',
     method: 'get',
     params
   })
};
// 统计详情扫码线
export const activity_scan_statistical = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/activity_scan_statistical/'+activity_id,
     method: 'get',
     params
   })
};

// 统计详情门店占比
export const activity_store_statistical = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/activity_store_statistical/'+activity_id,
     method: 'get',
     params
   })
};
// 统计详情
export const guide_activity_statisticalDetail = (activity_id)=>{
  return api_smart.request({
     url: 'admin/guide/activity_situation/activity_info/'+activity_id,
     method: 'get',
   })
};
// 扫码记录--门店
export const getGuideScanList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/scan/list',
     method: 'get',
     params
   })
};
// 扫码记录--经销商
export const getdealer_scanScanList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan/list',
     method: 'get',
     params
   })
};
// 领奖记录 领奖用户数:积分发放总量：红包发放总--门店
export const getGuideAwardCount = (params)=>{
  return api_smart.request({
     url: 'admin/guide/scan_award/count',
     method: 'get',
     params
   })
};
// 领奖记录 领奖用户数:积分发放总量：红包发放总--经销商
export const getdealer_scan_awardCount = (params)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan_award/count',
     method: 'get',
     params
   })
};
// 领奖记录导出--门店
export const getGuideAwardExport = (params)=>{
  return api_smart.request({
     url: 'admin/guide/scan_award/export',
     method: 'get',
     params
   })
};

// 领奖记录导出--经销商
export const getdealer_scan_awardExport = (params)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan_award/export',
     method: 'get',
     params
   })
};
// 扫码明细--门店
export const getGuideAwardMore = (scan_id)=>{
  return api_smart.request({
     url: 'admin/guide/scan/info/'+scan_id,
     method: 'get',
     
   })
};
// 扫码明细--经销商
export const getdealer_scanAwardMore = (scan_id)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan/info/'+scan_id,
     method: 'get',
     
   })
};
// 领奖记录详情--门店
export const getGuideAwardDetail = (scan_award_id)=>{
  return api_smart.request({
     url: 'admin/guide/scan_award/info/'+scan_award_id,
     method: 'get',
     
   })
};

// 领奖记录详情--经销商
export const getdealer_scan_awardDetail = (scan_award_id)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan_award/info/'+scan_award_id,
     method: 'get',
     
   })
};

// 领奖列表--门店
export const getGuideAwardList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/scan_award/list',
     method: 'get',
     params
   })
};
// 领奖列表--经销商
export const getdealer_scan_awardList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/dealer_scan_award/list',
     method: 'get',
     params
   })
};
// 商品分类
export const getCategoryList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/category',
     method: 'get',
     params
   })
};

// 商品详情
export const categoryDetails = (params)=>{
  return api_smart.request({
     url: 'admin/guide/category/'+params.id,
     method: 'get',
     params
   })
};
// 商品分类添加
export const categoryAdd = (data)=>{
  return api_smart.request({
     url: 'admin/guide/category',
     method: 'post',
     data
   })
};
// 商品分类修改
export const categoryEdit = (data)=>{
  return api_smart.request({
     url: 'admin/guide/category/'+data.id,
     method: 'patch',
     data
   })
};
// 商品分类排序
export const categorySort = (data)=>{
  return api_smart.request({
     url: 'admin/guide/category/sort/'+data.id,
     method: 'post',
     data
   })
};
// 商品分类删除
export const categoryDelete = (params)=>{
  return api_smart.request({
     url: 'admin/guide/category/'+params.id,
     method: 'delete',
     params
   })
};

// 商品列表
export const giftList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift',
     method: 'get',
     params
   })
};

// 运费模板
export const deliveryList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/delivery/list',
     method: 'get',
     params
   })
};

// 礼品多规格列表
export const giftSkuList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/sku/list',
     method: 'get',
     params
   })
};


// 添加礼品
export const giftAdd = (data)=>{
  return api_smart.request({
     url: 'admin/guide/gift',
     method: 'post',
     data
   })
};


// 礼品上下架
export const giftStatus = (data)=>{
  return api_smart.request({
     url: 'admin/guide/gift/status/'+data.id,
     method: 'post',
     data
   })
};

// 礼品删除
export const giftDelete = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/'+params.id,
     method: 'delete',
     params
   })
};

// 礼品批量上下架
export const giftAllStatus = (data)=>{
  return api_smart.request({
     url: 'admin/guide/gift/allStatus',
     method: 'post',
     data
   })
};
// 礼品批量设置运费
export const giftAllDelivery = (data)=>{
  return api_smart.request({
     url: 'admin/guide/gift/delivery',
     method: 'post',
     data
   })
};

// 礼品详情
export const giftDetails = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/'+params.id,
     method: 'get',
     params
   })
};

// 礼品修改
export const giftEdit = (data)=>{
  return api_smart.request({
     url: 'admin/guide/gift/'+data.id,
     method: 'patch',
     data
   })
};

// 礼品价格修改
export const giftEditPrice = (data)=>{
  return api_smart.request({
     url: '/admin/guide/gift/price/'+data.id,
     method: 'post',
     data
   })
};

//导购分析
export const giftStatistics = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/statistics/index',
     method: 'get',
     params
   })
};

//礼品兑换分析
export const giftStatisticsList = (params)=>{
  return api_smart.request({
     url: 'admin/guide/gift/statistics/gift',
     method: 'get',
     params
   })
};


//------------------导购订单---------------
//导购订单列表
export const guideOrderList = (params)=>{
  return axios.request({
     url: 'v2/guide/order/index',
     method: 'get',
     params
   })
};

//订单详情
export const guideOrderDetails = (params)=>{
  return axios.request({
     url: 'v2/guide/order/read',
     method: 'get',
     params
   })
};

//订单发货
export const guideOrderDelivery = (data)=>{
  return axios.request({
     url: 'v2/guide/order/delivery',
     method: 'post',
     data
   })
};

//修改地址
export const guideOrderReceiveAddress = (data)=>{
  return axios.request({
     url: 'v2/guide/order/receiveAddress',
     method: 'post',
     data
   })
};

//修改订单备注
export const guideOrderStoreRemark = (data)=>{
  return axios.request({
     url: 'v2/guide/order/storeRemark',
     method: 'post',
     data
   })
};

//查看物流
export const guideOrderLogistics = (params)=>{
  return axios.request({
     url: 'v2/guide/order/logistics',
     method: 'get',
     params
   })
};
//新增 指定发奖
export const prizeCreate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/prizeCreate/'+activity_id,
     method: 'post',
     data
   })
};
//修改 指定发奖
export const prizeUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/prizeUpdate/'+activity_id,
     method: 'post',
     data
   })
};
// 删除 指定发奖
export const prizeDelete = (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/prizeDelete/'+id,
     method: 'DELETE',
   })
};
//修改 默认发奖
export const updateSys = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/updateSys/'+activity_id,
     method: 'put',
     data
   })
};
export const updateBoss = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/updateBoss/'+activity_id,
     method: 'put',
     data
   })
};
export const updateBossNew = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/setSendAwardConfig/'+activity_id,
     method: 'post',
     data
   })
};
//概率发奖-列表
export const getGuideOddsList = (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/list/'+id,
     method: 'get',
   })
};
//概率发奖-详情
export const getGuideOddsDetail = (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/info/'+id,
     method: 'get',
   })
};
//概率发奖-添加
export const guideOddsAdd = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/store',
     method: 'post',
     data
   })
};
//概率发奖-修改
export const guideOddsEdit = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/update',
     method: 'post',
     data
   })
};
//概率发奖-删除
export const guideOddsDel = (data)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/delete',
     method: 'DELETE',
     data
   })
};
//概率发奖-删除
export const guideActivityAwardCount = (id)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/count/'+id,
     method: 'get',
   })
};
//添加奖项剩余可分配数量
export const guideActivityAwardSurplusCount = (params)=>{
  return api_smart.request({
     url: 'admin/guide/activity/award/getAwardCount',
     method: 'get',
     params
   })
};
//兑换码类礼品
export const getTotal = (params)=>{ 
  return axios.request({
    url: '/v2/guide/order/getRedeemCode',
    method: 'get',
    params
  })
};

//团购任务列表
export const getgrouptaskList = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/task',
    method: 'get',
    params
  })
};
//添加团购任务
export const addgrouptask = (params)=>{
  return api_smart.request({
     url: 'admin/guide/group/task',
     method: 'post',
     params
   }) 
};
//更新团购任务
export const updategrouptask = (params)=>{
  return api_smart.request({
     url: 'admin/guide/group/task/'+params.id,
     method: 'PATCH',
     params
   })
};
//团购任务详情
export const getgrouptaskDetail = (params)=>{
  return api_smart.request({
     url: 'admin/guide/group/task/'+params.id,
     method: 'get',
     params
   })
};
//团购任务删除
export const delgrouptask = (params)=>{
  return api_smart.request({
     url: 'admin/guide/group/task/'+params.id,
     method: 'DELETE',
     params
   })
};
//团购任务状态修改
export const upgrouptaskstatus = (params)=>{
  return api_smart.request({
     url: 'admin/guide/group/task/status/'+params.id,
     method: 'post',
     params
   })
};

//团购任务审核/奖励列表
export const getexamineList = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine',
    method: 'get',
    params
  })
};

//团购任务审核删除
export const delexamine = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine/'+params.id,
    method: 'DELETE',
    params
  })
};

//团购任务审核详情
export const detailexamine = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine/'+params.id,
    method: 'get',
    params
  })
};

//团购任务审核
export const taskexamine = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine/'+params.id,
    method: 'PATCH',
    params
  })
};

//团购任务审核申请二维码详情
export const getexamineCodeList = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine/code/'+params.id,
    method: 'get',
    params
  })
};

//团购任务奖励-状态
export const editargran = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/group/examine/send/'+params.id,
    method: 'post',
    params
  })
};

//签约任务列表
export const getcontractingList = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task',
    method: 'get',
    params
  })
};

//签约任务详情
export const detailcontracting = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/'+params.id,
    method: 'get',
    params
  })
};

//签约任务参与门店经销商详情
export const detailcontractingtask = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/detail/'+params.id,
    method: 'get',
    params
  })
};
//签约任务添加 - 第一步
export const fristcontracting = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task',
    method: 'post',
    params
  })
};
//签约任务添加 - 第二步
export const twocontracting = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/second/'+params.id,
    method: 'post',
    params
  })
};
//签约任务修改
export const editcontracting = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/'+params.id,
    method: 'PATCH',
    params
  })
};
//签约任务状态修改
export const editcontractingstatus = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/status/'+params.id,
    method: 'POST',
    params
  })
};

//签约任务删除
export const delcontracting = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/'+params.id,
    method: 'DELETE',
    params
  })
};
//签约任务参与门店经销商统计
export const contractingtaskstatistics = (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/contracting/task/statistics/'+params.id,
    method: 'get',
    params
  })
};
//超级导购中奖审核--门店
export const setexaminestore= (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/scan_award/audit/'+params.scan_award_id,
    method: 'post',
    params
  })
};
//超级导购中奖审核--经销商
export const setexaminedealer= (params)=>{ 
  return api_smart.request({
    url: 'admin/guide/dealer_scan_award/audit/'+params.scan_award_id,
    method: 'post',
    params
  })
};
//超级导购批量中奖审核--门店
export const setGuideAwardbatchAudit= (data)=>{ 
  return api_smart.request({
    url: 'admin/guide/scan_award/batchAudit',
    method: 'post',
    data
  })
};
//超级导购批量中奖审核--经销商
export const setGuidedealerbatchAudit= (data)=>{ 
  return api_smart.request({
    url: 'admin/guide/dealer_scan_award/batchAudit',
    method: 'post',
    data
  })
};